import { PageContext } from 'context/PageContext';
import { memo, useContext } from 'react';

export const ProductCalculatorSelectorPage: React.FC<PageModel> = memo(() => {
	const pageContext = useContext(PageContext);
	// The generic PageModel does not carry the selector-specific fields; this
	// template is only rendered when contentType === 'ProductCalculatorSelectorPage',
	// so it is safe to narrow to the dedicated model here.
	const pageModel = pageContext?.pageModel as ProductCalculatorSelectorPageModel | undefined;

	const title = pageModel?.title;
	const description = pageModel?.description;
	const products = pageModel?.products ?? [];

	return (
		<div data-page-type='ProductCalculatorSelectorPage'>
			{title && <h1>{title}</h1>}
			{description && <div dangerouslySetInnerHTML={{ __html: description }} />}
			{products.length > 0 && (
				<>
					<hr />
					<ul data-testid='product-calculator-selector-products'>
						{products.map((product, index) => (
							<li key={product.salesProduct ?? product.url ?? index}>
								{index > 0 && <hr />}
								<dl>
									<dt>
										<strong>title</strong>
									</dt>
									<dd>{product.title}</dd>
									<dt>
										<strong>imageUrl</strong>
									</dt>
									<dd>{product.imageUrl}</dd>
									<dt>
										<strong>url</strong>
									</dt>
									<dd>{product.url}</dd>
									<dt>
										<strong>salesProduct</strong>
									</dt>
									<dd>{product.salesProduct}</dd>
								</dl>
							</li>
						))}
					</ul>
				</>
			)}
		</div>
	);
});

ProductCalculatorSelectorPage.displayName = 'ProductCalculatorSelectorPage';
